import { config } from 'src/config';
import { request } from 'src/shared/utils/request';

type CreateLeadResponse = {
  id: number;
  submitting_user_id: number;
  recipient_org_id: number;
  email: string;
  phone_number: string;
  full_name: string;
  location_postal_code: string;
  created_at: string;
  updated_at: string;
};

const createLead = async (
  orgPublicId: string,
  email: string,
  phoneNumber: string,
  postalCode: string,
  fullName: string,
  sendHomeownerEmail: boolean,
) => {
  const endpoint = `${config.API_URI_V2}/orgs/${orgPublicId}/leads`;
  const formData = new FormData();

  formData.append('lead[email]', email);
  formData.append('lead[phone_number]', phoneNumber);
  formData.append('lead[location_postal_code]', postalCode);
  formData.append('lead[full_name]', fullName);
  formData.append(
    'lead[send_homeowner_email]',
    sendHomeownerEmail ? 'true' : 'false',
  );

  const requestOptions = {
    method: 'POST',
    body: formData,
  };

  const resp = await request(endpoint, requestOptions);
  const lead = await resp.json<CreateLeadResponse>();
  return lead;
};

export { createLead, CreateLeadResponse };
